import React from 'react';

interface LayoutShellProps {
  className: string;
  transactionType?: string;
  wrapRef?: React.Ref<HTMLDivElement>;
  containerRef?: React.Ref<HTMLElement>;
  children: React.ReactNode;
}

const LayoutShell = ({
  className,
  transactionType,
  wrapRef,
  containerRef,
  children,
}: LayoutShellProps) => (
  <div {...{ transaction_type: transactionType }} className={className}>
    <div className={'wrap'} ref={wrapRef}>
      <main ref={containerRef} className={'main-container'}>
        {children}
      </main>
    </div>
  </div>
);

export default LayoutShell;
